import { useApolloClient, useQuery } from '@apollo/client';
import { FIND_HOTEL_QUERY } from '../infrastructure/graphql/findHotel.gql';
import { FindHotel, FindHotelVariables } from '../infrastructure/graphql/types/FindHotel';

export interface FindHotelQueryOptions {
  pollInterval?: number;
}

export function useFindHotel(
  { id }: Partial<FindHotelVariables>,
  { pollInterval }: FindHotelQueryOptions = {}
) {
  const { data, ...rest } = useQuery<FindHotel>(FIND_HOTEL_QUERY, {
    variables: { id },
    skip: !id,
    pollInterval,
  });

  const client = useApolloClient();

  function refetchHotelQuery() {
    client.query({
      query: FIND_HOTEL_QUERY,
      variables: { id },
      fetchPolicy: 'network-only',
    });
  }

  const hotel = data?.hotel;

  return {
    hotel,
    refetchHotelQuery,
    ...rest,
  };
}
